import OrderHistoryContainer from "../../../../Components/Applications/ECommerce/OrderHistory/OrderHistoryContainer";

const OrderHistory = () => {
  return <OrderHistoryContainer />;
};

export default OrderHistory;
